import React, {Component, ReactNode, ErrorInfo} from 'react'
import {reportError} from '../helpers/reportError.js'
import ErrorMessage from './errorMessage.js'

// Interface for component state
interface ErrorBoundaryState {
  hasError: boolean;
}

// Interface for component props
interface ErrorBoundaryProps {
  children: ReactNode;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportError(window.location.href, error, errorInfo);
  }

  render(): ReactNode {
    
    if (this.state.hasError) {
      // You can render custom fallback UI
      const message = `Because of an internal error we are not able to process your request. 
      Rest assured, the error was logged and we will have our best engineers investigating it!`
      
      return (
        <>
          <ErrorMessage message={message} />
        </>
      )
    }
    return this.props.children; 
  }
}